import { INBOX_OPEN_CLOSE_LEAVE_GROUP } from '../actions';

const openLeaveGroup = () => (dispatch) =>
  dispatch({
    type: INBOX_OPEN_CLOSE_LEAVE_GROUP,
    payload: {
      leaveGroupOpened: true,
    },
  });

export default openLeaveGroup;
